module.exports = __webpack_public_path__ + "a17d279f/img/comments-icon.fdec7fdb.svg";